export default "__VITE_ASSET__7fe4010b__"